import { Component, OnInit} from '@angular/core';
import { CalculatorServices } from 'src/app/Services/calculator.service';
declare var $: any;
@Component({
  selector: 'app-logged',
  templateUrl: './logged.component.html',
  styleUrls: ['./logged.component.scss']
})
export class LoggedComponent implements OnInit {
  validation: boolean;
  constructor(private calculatorService: CalculatorServices) {
   }
  ngOnInit() {
    this.calculatorService.change.subscribe(isOpen => {this.validation = isOpen;});
    $('body').removeAttr('class')
  }

  closeModal(event){
    this.validation = event;
  }

}
